// SyncFailureBanner
// -----------------
// A self-healing system-health banner shown to supervisor-and-above users (the
// admin "Supervisor" role + SuperUser) on every internal screen while one or more
// DFV Service changes have permanently FAILED to auto-sync to Unleashed
// (unleashed_push_queue status 'error'). It re-queries the count on mount and
// whenever the active path changes (pathKey, from AppShell), so it clears
// automatically once the errored jobs are retried / deleted — no Edge-Function →
// banner coupling. Sibling of PushFailureBanner (the Sales Order push equivalent).
//
// Gated to isAdminRole, so a shelter caseworker never sees it (and the count query
// never even runs for them).

import { useEffect, useState } from "react";
import { countErroredQueueJobs } from "../data/unleashedPushQueue";
import { isAdminRole } from "./access";
import { useSession } from "./SessionContext.jsx";

export function SyncFailureBanner({ pathKey, onNavigate }) {
  const { user } = useSession();
  const gated = isAdminRole(user);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!gated) {
      setCount(0);
      return;
    }
    let alive = true;
    (async () => {
      const n = await countErroredQueueJobs();
      if (alive) setCount(n);
    })();
    return () => {
      alive = false;
    };
  }, [gated, pathKey]);

  if (!gated || count <= 0) return null;

  return (
    <div
      role="alert"
      style={{
        background: "#C62828",
        color: "white",
        textAlign: "center",
        padding: "12px 20px",
        fontSize: 14,
        fontFamily: "system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,sans-serif",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 16,
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      }}
    >
      <span style={{ fontWeight: 700 }}>
        ⚠️ {count} DFV Service change{count === 1 ? "" : "s"} failed to sync to Unleashed.
      </span>
      <button
        type="button"
        onClick={() => onNavigate("push_queue")}
        style={{
          background: "white",
          color: "#C62828",
          border: "none",
          borderRadius: 6,
          padding: "6px 16px",
          fontSize: 13,
          cursor: "pointer",
          fontWeight: 700,
          fontFamily: "inherit",
        }}
      >
        Review Push List
      </button>
    </div>
  );
}
